<div class="container-fluid glb-popup vehicle-booking-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
  @if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
  }


  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">
        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>
        <div class="mb-4">
          <div>
            <div class="title fw-bold mb-2">
              <div class="fs-6">Guest Requested Details</div>
            </div>
            <div class="row">
              <div class="col-lg-2">
                <span class="p-float-label w-100 mb-3">
                  <p-dropdown [dropdownIcon]="'fa fa-caret-down'" class="w-100" [options]="statuses"
                    formControlName="bookingStatus" optionLabel="name" optionValue="value"
                  placeholder="Booking Status"></p-dropdown>
                  <label for="bookingStatus">Booking Status</label>
                  @for (validation of validationMessages.bookingStatus; track validation) {
                    <span>
                      @if (form1.get('bookingStatus').hasError(validation.type) && (form1.get('bookingStatus').dirty || form1.get('bookingStatus').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
              <div class="col-lg-2">
                <span class="p-float-label w-100 mb-3">
                  <p-dropdown [dropdownIcon]="'fa fa-caret-down'" class="w-100" [options]="vehicles" formControlName="vehiclePref"
                  optionLabel="name" optionValue="value" placeholder="Vehicle Pref"></p-dropdown>
                  <label for="vehiclePref">Vehicle Pref</label>
                  @for (validation of validationMessages.vehiclePref; track validation) {
                    <span>
                      @if (form1.get('vehiclePref').hasError(validation.type) && (form1.get('vehiclePref').dirty || form1.get('vehiclePref').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-2">
                <span class="p-float-label required-field w-100 mb-3">
                  <p-dropdown [dropdownIcon]="'fa fa-caret-down'" class="w-100" [options]="pickupDrops"
                    formControlName="pickUpLocPref" optionLabel="name" optionValue="value"
                  placeholder="Pick Up Location Pref"></p-dropdown>
                  <label for="pickUpLocPref">Pick Up Location Pref</label>
                  @for (validation of validationMessages.pickUpLocPref; track validation) {
                    <span>
                      @if (form1.get('pickUpLocPref').hasError(validation.type) && (form1.get('pickUpLocPref').dirty || form1.get('pickUpLocPref').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
              <div class="col-lg-2">
                <span class="p-float-label required-field w-100 mb-3">
                  <p-dropdown [dropdownIcon]="'fa fa-caret-down'" class="w-100" [options]="pickupDrops"
                    formControlName="dropOffLocPref" optionLabel="name" optionValue="value"
                  placeholder="Drop Off Location Pref"></p-dropdown>
                  <label for="dropOffLocPref">Drop Off Location Pref</label>
                  @for (validation of validationMessages.dropOffLocPref; track validation) {
                    <span>
                      @if (form1.get('dropOffLocPref').hasError(validation.type) && (form1.get('dropOffLocPref').dirty || form1.get('dropOffLocPref').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-2">
                <span class="p-float-label w-100 mb-3">
                  <p-calendar appendTo="body" formControlName="pickUpDateTimePref" [showTime]="true" hourFormat="12"
                    inputId="pickUpDateTimePref">
                  </p-calendar>
                  <label for="pickUpDateTimePref">Pick Up Date Time Pref</label>
                  @for (validation of validationMessages.pickUpDateTimePref; track validation) {
                    <span>
                      @if (form1.get('pickUpDateTimePref').hasError(validation.type) && (form1.get('pickUpDateTimePref').dirty || form1.get('pickUpDateTimePref').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>

              <div class="col-lg-2">
                <span class="p-float-label w-100 mb-3">
                  <p-calendar appendTo="body" formControlName="dropOffDateTimePref" [showTime]="true" hourFormat="12"
                    inputId="dropOffDateTimePref">
                  </p-calendar>
                  <label for="dropOffDateTimePref">Drop Off Date Time Pref</label>
                  @for (validation of validationMessages.dropOffDateTimePref; track validation) {
                    <span>
                      @if (form1.get('dropOffDateTimePref').hasError(validation.type) && (form1.get('dropOffDateTimePref').dirty || form1.get('dropOffDateTimePref').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4">
                <span class="p-float-label w-100 mb-3">
                  <textarea formControlName="notesFromCustomer" id="notesFromCustomer" [rows]="2" pInputTextarea></textarea>
                  <label for="notesFromCustomer">Notes From Customer</label>
                  @for (validation of validationMessages.notesFromCustomer; track validation) {
                    <span>
                      @if (form1.get('notesFromCustomer').hasError(validation.type) && (form1.get('notesFromCustomer').dirty || form1.get('notesFromCustomer').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
            </div>

          </div>
          <div>
            <div class="title fw-bold mb-2">
              <div class="fs-6">Guest and Reservation info</div>
            </div>
            <div class="row">
              <div class="col-lg-2">
                <span class="p-float-label required-field w-100 mb-3">
                  <input formControlName="primaryDriverName" id="primaryDriverName" type="text"
                    pInputText>
                  <label for="primaryDriverName">Primary Driver Name</label>
                  @for (validation of validationMessages.primaryDriverName; track validation) {
                    <span>
                      @if (form1.get('primaryDriverName').hasError(validation.type) && (form1.get('primaryDriverName').dirty || form1.get('primaryDriverName').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
              <div class="col-lg-2">
                <span class="p-float-label required-field w-100 mb-3">
                  <input formControlName="reservationId" id="reservationId" type="text" [readonly]="reservationId" pInputText
                    [pTooltip]="vehicleBookingId && orderId ? 'Click here to open reservation' : ''" tooltipPosition="top"
                    [class.reservation-clickable]="vehicleBookingId && orderId" (click)="openReservation()">
                  <label for="reservationId">Reservation #</label>
                  @for (validation of validationMessages.reservationId; track validation) {
                    <span>
                      @if (form1.get('reservationId').hasError(validation.type) && (form1.get('reservationId').dirty || form1.get('reservationId').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-2">
                <span class="p-float-label w-100 mb-3">
                  <p-calendar appendTo="body" formControlName="cancelDate" [showTime]="true" hourFormat="12" inputId="cancelDate">
                  </p-calendar>
                  <label for="cancelDate">Cancel Date </label>
                  @for (validation of validationMessages.cancelDate; track validation) {
                    <span>
                      @if (form1.get('cancelDate').hasError(validation.type) && (form1.get('cancelDate').dirty || form1.get('cancelDate').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
            </div>
          </div>

          <div>
            <div class="title fw-bold mb-2">
              <div class="fs-6">Pickup and drop-off details (Confirmed)</div>
            </div>
            <div class="row">
              <div class="col-lg-2">
                <span class="p-float-label required-field w-100 mb-3">
                  <p-dropdown [dropdownIcon]="'fa fa-caret-down'" class="w-100" [options]="pickupDrops"
                    formControlName="pickUpLoc" optionLabel="name" optionValue="value"
                  placeholder="Pick Up Location"></p-dropdown>
                  <label for="pickUpLoc">Pick Up Location </label>
                  @for (validation of validationMessages.pickUpLoc; track validation) {
                    <span>
                      @if (form1.get('pickUpLoc').hasError(validation.type) && (form1.get('pickUpLoc').dirty || form1.get('pickUpLoc').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
              <div class="col-lg-2">
                <span class="p-float-label required-field w-100 mb-3">
                  <p-dropdown [dropdownIcon]="'fa fa-caret-down'" class="w-100" [options]="pickupDrops"
                    formControlName="dropOffLoc" optionLabel="name" optionValue="value"
                  placeholder="Drop Off Location"></p-dropdown>
                  <label for="dropOffLoc">Drop Off Location </label>
                  @for (validation of validationMessages.dropOffLoc; track validation) {
                    <span>
                      @if (form1.get('dropOffLoc').hasError(validation.type) && (form1.get('dropOffLoc').dirty || form1.get('dropOffLoc').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-2">
                <span class="p-float-label w-100 mb-3">
                  <p-calendar appendTo="body" formControlName="pickUpDateTime" [showTime]="true" hourFormat="12"
                    inputId="pickUpDateTime">
                  </p-calendar>
                  <label for="pickUpDateTime">Pick Up Date Time </label>
                  @for (validation of validationMessages.pickUpDateTime; track validation) {
                    <span>
                      @if (form1.get('pickUpDateTime').hasError(validation.type) && (form1.get('pickUpDateTime').dirty || form1.get('pickUpDateTime').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
              <div class="col-lg-2">
                <span class="p-float-label w-100 mb-3">
                  <p-calendar appendTo="body" formControlName="dropOffDateTime" [showTime]="true" hourFormat="12"
                    inputId="dropOffDateTime">
                  </p-calendar>
                  <label for="dropOffDateTime">Drop Off Date Time </label>
                  @for (validation of validationMessages.dropOffDateTime; track validation) {
                    <span>
                      @if (form1.get('dropOffDateTime').hasError(validation.type) && (form1.get('dropOffDateTime').dirty || form1.get('dropOffDateTime').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
            </div>
          </div>

          <div>
            <div class="title fw-bold mb-2">
              <div class="fs-6">Rental Agency Info</div>
            </div>
            <div class="row">
              <div class="col-lg-2">
                <span class="p-float-label required-field w-100 mb-3">
                  <p-dropdown [dropdownIcon]="'fa fa-caret-down'" class="w-100" [options]="agencies"
                    formControlName="agencyName" optionLabel="name" optionValue="value"
                  placeholder="Agency Name"></p-dropdown>
                  <label for="agencyName">Agency Name</label>
                  @for (validation of validationMessages.agencyName; track validation) {
                    <span>
                      @if (form1.get('agencyName').hasError(validation.type) && (form1.get('agencyName').dirty || form1.get('agencyName').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
              <div class="col-lg-2">
                <span class="p-float-label w-100 mb-3">
                  <p-dropdown dropdownIcon="fa fa-caret-down" class="w-100" [options]="vehicles"
                    formControlName="agencyVehicleBooked" optionLabel="name" optionValue="value"
                  placeholder="Agency Vehicle Booked" (onChange)="onVehicleChange($event)"></p-dropdown>
                  <label for="agencyVehicleBooked">Agency Vehicle Booked</label>
                  @for (validation of validationMessages.agencyVehicleBooked; track validation) {
                    <span>
                      @if (form1.get('agencyVehicleBooked').hasError(validation.type) && (form1.get('agencyVehicleBooked').dirty || form1.get('agencyVehicleBooked').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-2">
                <span class="p-float-label required-field w-100 mb-3">
                  <input formControlName="agencyConfNumber" id="agencyConfNumber" type="text" pInputText>
                  <label for="agencyConfNumber">Agency Conf Number</label>
                  @for (validation of validationMessages.agencyConfNumber; track validation) {
                    <span>
                      @if (form1.get('agencyConfNumber').hasError(validation.type) && (form1.get('agencyConfNumber').dirty || form1.get('agencyConfNumber').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
              <div class="col-lg-2 ctm-retail-upgrade-input">
                <span class="p-float-label required-field w-100 mb-3">
                  <p-inputNumber formControlName="retailUpgradeCostPerDay" inputId="currency-us"
                    mode="currency" currency="USD" locale="en-US">
                  </p-inputNumber>
                  <label for="retailUpgradeCostPerDay">Retail Upgrade Cost Per Day</label>
                  @for (validation of validationMessages.retailUpgradeCostPerDay; track validation) {
                    <span>
                      @if (form1.get('retailUpgradeCostPerDay').hasError(validation.type) && (form1.get('retailUpgradeCostPerDay').dirty || form1.get('retailUpgradeCostPerDay').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
            </div>
          </div>
          <!-- <div>
          <div class="title fw-bold mb-2">
            <div class="fs-6">Pickup and drop-off details (preferred)</div>
          </div>

        </div> -->


        <div>
          <div class="title fw-bold mb-2">
            <div class="fs-6">Notes and communication</div>
          </div>

          <div class="row">
            <div class="col-lg-4">
              <span class="p-float-label w-100 mb-3">
                <textarea formControlName="notesToCustomer" id="notesToCustomer" [rows]="2" pInputTextarea></textarea>
                <label for="notesToCustomer">Notes To Customer</label>
                @for (validation of validationMessages.notesToCustomer; track validation) {
                  <span>
                    @if (form1.get('notesToCustomer').hasError(validation.type) && (form1.get('notesToCustomer').dirty || form1.get('notesToCustomer').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4">
              <span class="p-float-label w-100 mb-3">
                <textarea formControlName="notesToOps" id="notesToOps" [rows]="2" pInputTextarea></textarea>
                <label for="notesToOps">Notes To Ops</label>
                @for (validation of validationMessages.notesToOps; track validation) {
                  <span>
                    @if (form1.get('notesToOps').hasError(validation.type) && (form1.get('notesToOps').dirty || form1.get('notesToOps').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4">
              <span class="p-float-label w-100 mb-3">
                <textarea formControlName="contractTerms" id="contractTerms" [rows]="2" pInputTextarea></textarea>
                <label for="contractTerms">Contract Terms</label>
                @for (validation of validationMessages.contractTerms; track validation) {
                  <span>
                    @if (form1.get('contractTerms').hasError(validation.type) && (form1.get('contractTerms').dirty || form1.get('contractTerms').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <hr>
    <div class="row m-0">
      <div class="col-lg-12">
        <div class="btn-group">
          <div class="button-group">
            @if (vehicleBookingId) {
              <button pButton class="btn-delete p-button-outlined p-button-danger"
              [disabled]="formLoading" (click)="onFormDelete()">Delete</button>
            }
          </div>

          <div class="button-group">
            <button pButton class="btn-cancel p-button-text" [disabled]="formLoading" [mat-dialog-close]="formLoading ? null : true">Cancel</button>
            @if (!vehicleBookingId) {
              <button pButton class="btn-addt p-button" [disabled]="formLoading" (click)="formAdd()">
                @if (formLoading) { <i class="pi pi-spin pi-spinner mr-1"></i> } Add
              </button>
            }

            @if (vehicleBookingId) {
              <button pButton class="btn-upt p-button" [disabled]="formLoading"
              (click)="formUpdate()">
                @if (formLoading) { <i class="pi pi-spin pi-spinner mr-1"></i> } Update
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>